<template>
  <div  role="search" aria-label="You can search for ways 2-1-1 can help by providing what you are looking for and the zip code you currently live in.">
    <div class="search__background" autocomplete="off">
        <div class="search__container" v-if="searchType === 'serviceArea'">
          <li class="tax" id="tax-section">
            <label for="tax-term" class="label--color">I am looking for:</label>
              <input
                id="tax-term"
                type="search"
                name="taxonomy"
                :placeholder="loaded ? 'food, rent payment assistance, diapers, etc…' : 'Loading...'"
              />
              <p role="alert" id="tax-error" class="error_msg" style="display: none;">
                Please enter a few key words and select a service that best matches your needs.
              </p>
              <p role="alert" id="tax-warn"  class="warn_msg" style="display: none;">
                Sorry, there are no matches for this service.  Try again using a different term or contact us by <strong>dialing 2-1-1 or 844-875-9211</strong>, 24 hours a day, 7 days a week.
              </p>
          </li>
          <li class="zip" id="zip-section">
            <label for="zip-code" class="label--color">I live in zip code:</label>
            <a href="#" role="button" class="tooltip" aria-describedby="zipDesc"> ? <span role="dialog" id="zipDesc" class="tooltiptext">Program eligibility is determined by your primary residential zip code.  If you do not know your zip code, please dial 2-1-1 or (844) 875-9211.</span></a>
              <input
                id="zip-code"
                type="search"
                name="zip-code"
                placeholder="enter zip code..."
              />
              <p role="alert" id="zip-error" class="error_msg" style="display: none;">
                Please enter a valid Michigan zip code and select one that matches where you live.
              </p>
              <p role="alert" id="zip-warn" class="warn_msg" style="display: none;">
                Please enter a valid Michigan zip code and select one that matches where you live.
              </p>
              <p role="alert" id="split-zip" style="display: none;">
                There is more than one county within your zip code, please select which county you live in.
              </p>
          </li>
          <li class="cta submit">
            <button id="search-button" value="submit" @click="handleClickServiceArea">Find Help</button>
          </li>
        </div>
        <div class="search__container" v-if="searchType === 'organization'">
          <li class="search" id="search-section">
            <label for="search-term" class="label--color">Search for services by agency name</label>
              <input
                id="search-term"
                type="search"
                placeholder="Enter agency name..."
              />
              <p role="alert" id="search-error" class="error_msg" style="display: none;">
                Please enter a the name of the agency.
              </p>
              <p role="alert" id="search-warn"  class="warn_msg" style="display: none;">
                Sorry, there are services for this agency. Try again using a different agency name or contact us by <strong>dialing 2-1-1 or 844-875-9211</strong>, 24 hours a day, 7 days a week.
              </p>
          </li>
          <li class="cta submit">
            <button id="search-button" value="submit" @click="handleClickOrganization">Find Services</button>
          </li>
        </div>
    </div>
  </div>
</template>

<script>
import { s3bucket } from "../api/s3-bucket";
import { autocomplete } from './shared.js' 
import { SocialService } from "../api/social-service";
import { setSession } from '../api/set-session';

export default {
  name: "ServicesSearchBox",
  props: {
    searchTerm: {
      type: String,
    },
    searchType: {
      type: String,
      default: 'serviceArea'
    },
    taxonomyTerm: String,
    zipcode: String,
    labelColor: {
      type: String,
      default: '#757575'
    }
  },
  data: function () {
    return {
      taxonomies: [],
      taxTermsLoaded: false,
      taxonomyObjects: [],
      taxieTerm: null,
      zippyCode: null,
      zippies: [],
      popularTaxonomies: [],
      loaded: false
    };
  },
  async mounted(){
    this.loaded = false
    await setSession(null, null, true)
    const services = new SocialService();
    const areas = await services.GetAreas("zipcode")
    this.zippies = areas.map(a => a.name)
    const s3 = new s3bucket()
    const terms = await s3.getTaxTerms()
    this.taxonomies = terms.map(el => el.taxonomy_name_reference);
    this.taxonomyObjects = terms;
    this.popularTaxonomies = terms.filter(t => !!t.priority).map( m => m.taxonomy_name_reference );
    this.loaded = true;
    // TODO: why cant i access the shadow dom elements from mountted???????????????
    // const shadowRoot = document.querySelector("cie-service-search").shadowRoot;
  },
  updated() {
    if(this.searchType === "serviceArea" ){
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot;
      console.log("shadowRoot", shadowRoot)
      autocomplete({
          section: shadowRoot.getElementById("tax-section"),
          dropdownItems: this.taxonomies,
          shadowRoot,
          isZip: false,
          popularTax: this.popularTaxonomies,
          showList: false,
          maxDDItems: 50
      });
      autocomplete({
          section: shadowRoot.getElementById("zip-section"),
          dropdownItems: this.zippies,
          shadowRoot,
          isZip: true,
          popularTax: false,
          showList: false,
          maxDDItems: 50
      });
      this.handleEvent(this.taxieTerm, this.zippyCode)
      this.populateFields()
      this.updateLabelColor()
    }
    else {
      // populate search field from prop
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot
      const searchElm = shadowRoot.getElementById("search-term")
      if(this.searchTerm === "undefined" || this.searchTerm === "null") this.searchTerm = ""
      if(!this.searchTerm || !searchElm) return
      searchElm.value = this.searchTerm
      this.handleClickOrganization()
    }
  },
  methods: {
    updateLabelColor: function() {
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot
      const label = shadowRoot.querySelectorAll(".label--color")
      if(!label[0] || !label[1]) return
      label[0].setAttribute('style', `color:${this.labelColor};`)
      label[1].setAttribute('style', `color:${this.labelColor};`)
    },
    populateFields: function(){
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot
      const taxEl = shadowRoot.getElementById("tax-term")
      const zipEl = shadowRoot.getElementById("zip-code")
      if(!taxEl || !zipEl) return
      if(this.taxieTerm && this.zippyCode){
        taxEl.value = this.taxieTerm
        zipEl.value = this.zippyCode
        return
      }
      if(this.taxonomyTerm && this.zipcode){
        taxEl.value = this.taxonomyTerm
        zipEl.value = this.zipcode
        return
      }
    },
    handleClickOrganization: function(){
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot
      const searchTerm = shadowRoot.getElementById("search-term").value
      this.searchTermie = searchTerm
      if(!searchTerm) {
        shadowRoot.getElementById("search-error").setAttribute('style', "display: block;")
        shadowRoot.getElementById("search-term").setAttribute('required', "required")
      }
      else {
        shadowRoot.getElementById("search-error").setAttribute('style', "display: none;")
        let serviceQuery
        // if string contains only numbers search by org id
        if (Number(searchTerm)) {
          serviceQuery = `{"organization_id":"${searchTerm}"}&per_page=100&sort_by=organization_id`
        }
        else {
          serviceQuery = `{"$table.field:like": [{"location.organization_name": "${searchTerm}"}]}&per_page=100&sort_by=organization_id`
        }
        return this.$emit('cie_service_list', {serviceQuery, searchTerm})
      }
    },
    handleClickServiceArea: function() {
      const shadowRoot = document.querySelector("cie-service-search").shadowRoot
      const taxEl = shadowRoot.getElementById("tax-term")
      const zipEl = shadowRoot.getElementById("zip-code")
      // tax and zip are only set in the autocomplete if they are valid
      const taxTermSelected = taxEl.userSelection
      const zipSelecteed = zipEl.userSelection
      this.taxieTerm = taxTermSelected
      this.zippyCode = zipSelecteed
      if(!taxTermSelected) {
        shadowRoot.getElementById("tax-error").setAttribute('style', "display: block;")
        shadowRoot.getElementById("tax-term").setAttribute('required', "required")
      }
      if(!zipSelecteed) {
        const splitZipHidden = shadowRoot.getElementById("split-zip").offsetParent === null
        if(splitZipHidden){
          shadowRoot.getElementById("zip-error").setAttribute('style', "display: block;")
          shadowRoot.getElementById("zip-code").setAttribute('required', "required")
        }
      }
      if(taxTermSelected && zipSelecteed) {
        this.handleEvent(taxTermSelected, zipSelecteed);
        // taxEl.value = ''
        // zipEl.value = ''
        // taxEl.userSelection = ''
        // zipEl.userSelection = ''
        shadowRoot.getElementById("zip-code").removeAttribute('required')
        shadowRoot.getElementById("tax-term").removeAttribute('required')
        // formReset is used so the onBlur event knows not to throw an error
        // when an input is empty after form submission
        shadowRoot.getElementById("search-button").formReset = true
      }
    },
    handleEvent: function(taxonomyTerm, zipcode){
      if(taxonomyTerm && (zipcode || this.zipcode)) {
        const zip = zipcode || this.zipcode
        return this.getAndSendEventData(taxonomyTerm, zip)
      }
      if(zipcode && (taxonomyTerm || this.taxonomyTerm)) {
        const tax = taxonomyTerm || this.taxonomyTerm
        return this.getAndSendEventData(tax, zipcode)
      }
      if(this.taxonomyTerm && this.zipcode){
        const shadowRoot = document.querySelector("cie-service-search").shadowRoot
        const taxEl = shadowRoot.getElementById("tax-term")
        const zipEl = shadowRoot.getElementById("zip-code")
        if(!taxEl || !zipEl) return
        taxEl.userSelection = this.taxonomyTerm
        zipEl.userSelection = this.zipcode
        return this.getAndSendEventData(this.taxonomyTerm, this.zipcode)
      }
    },
    getAndSendEventData: function(taxonomyTerm, zipcode){
        const taxObject = this.taxonomyObjects.find(term => {
          if(term.taxonomy_name_reference.toLowerCase() === taxonomyTerm.toLowerCase()){
            // use char case of official term
            taxonomyTerm = term.taxonomy_name_reference
            return true
          }
          return false
          })
        const taxonomyCode = taxObject && taxObject.taxonomy_code || "";
        const taxonomyCategory = taxObject && taxObject.category || "";
        const taxonomySubcategory = taxObject && taxObject.subcategory || "";
        return this.$emit('cie_service_list', {taxonomyCode, taxonomyTerm, taxonomyCategory, taxonomySubcategory, zipcode})
    }
  },
};
</script>
<style type="text/scss">
.search__background {
  background-color: transparent;
  margin: 0rem;
  padding: 2rem 0rem 3rem 0rem;
}
.search__container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  align-content: stretch;
  gap: 4rem;
  margin: 0rem auto;
  padding: 0rem;
  max-width: 100%;
  list-style: none;
}
.search__container li {
  padding: 0rem;
}
.tax {
  position: relative;
  flex-grow: 3;
}
.zip {
  position: relative;
  flex-grow: 1;
}
.search {
  position: relative;
  flex-grow: 1;
}
.cta {
  flex-shrink: 1;
}
.search__container .submit button {
  background-color: white !important;
  color: #353535;
  border: thick solid #D04B24;
  border-radius: .5rem;
  font-size: 20px;
  font-weight: 500;
  padding: 18px 28px;
  cursor: pointer;
  white-space: nowrap;
  text-transform: uppercase;

}
.search__container .submit button:hover {
  background-color: #D04B24 !important;
  color: #fff;
}
.search__container input {
  border: none;
  border-radius: .5rem;
  background-color: white;
  color: #353535;
  padding: 20px;
  font-size: 20px;
  margin: .5rem 0rem 0rem 0rem;
  width: 100%;
}
.search__container input:focus {
  outline: medium solid #659dd8;
}
.search__container input::placeholder {
  color: #757575 !important;
}
.search__container input:invalid,
.invalid {
  outline: medium solid #CC4B24 !important;
}
.search__container label {
  display: inline-block;
}
.search__container .error_msg, 
.zip_error_msg {
  line-height: 1.3;
  font-size: 16px;
  padding: 16px 24px;
  margin: 8px 0px;
  color: white;
  background-color: #CC4B24;
  border-radius: .5rem;
  position: absolute;
  top: 100%;
  width: auto;
}
.search__container .warn_msg {
  line-height: 1.3;
  font-size: 16px;
  padding: 16px 24px;
  margin: 8px 0px;
  color: #9B5712;
  background-color: #FFEADB;
  position: absolute;
  top: 100%;
  width: auto;
  border-radius: .5rem;
}
.autocomplete-items {
  margin-top: 14px;
  border: thin solid #d9d9d9;
  border-bottom: none;
  border-top: none;
  position: absolute;
  z-index: 1000;
  top: 100%;
  left: 0;
  right: 0;
  overflow-y: scroll;
  max-height: calc(3rem * 7.5);
  max-width: inherit;
  box-shadow: 0px 3px 15px rgba(0,0,0,0.1);
  border-radius: 8px;
}
.autocomplete-items div {
  padding: 12px;
  color: #353535;
  font-size: 18px;
  cursor: pointer;
  background-color: white;
  border-bottom: thin solid #f2f2f2;
}
.autocomplete-items div:hover,
.autocomplete-active {
  background-color: #F0F0F0 !important;
}
.autocomplete-items::-webkit-scrollbar {
  width: 8px;
}
.autocomplete-items::-webkit-scrollbar-track {
  background: white;
}
.autocomplete-items::-webkit-scrollbar-thumb {
  background: #999;
  width: 4px;
  min-height: 2.5rem;
  border-radius: .25rem;
}
.autocomplete-items::-webkit-scrollbar-thumb:hover {
  background: #777;
}
.tooltip {
  position: relative;
  display: inline-block;
  text-align: center;
  color: white;
  background-color: #659dd8;
  border-radius: 100%;
  min-width: 1em;
  max-height: 1em;
  max-width: 1em;
  max-height: 1em;
  margin: -.5rem 0rem 0rem .7rem;
  padding: .5rem .1rem !important;
  font-weight: 500;
  line-height: 1rem;
  font-size: .9em;
  cursor: pointer;
  text-decoration: none;
}

.tooltiptext {
  font-size: 16px;
  line-height: 1.5;
  visibility: hidden;
  min-width: 20rem;
  max-width: 20rem;
  background-color: #757575;
  color: white;
  text-align: left;
  border-radius: .5rem;
  padding: 1.5rem;
  position: absolute;
  z-index: 1;
  left: 2rem;
  top: -75%;
  box-shadow: 0px 3px 15px rgba(0,0,0,0.1);
}
.tooltip:hover .tooltiptext,
.tooltip:focus .tooltiptext {
  visibility: visible;
}

@media screen and (max-width: 1400px) {
.search__container {
  max-width: 95%;
  gap: 2rem;
}
.tax {
  flex-basis: 60%;
  flex-grow: 3;
}
.zip {
  flex-grow: 1;
}
.cta {
  flex-basis: 35%;
  flex-grow: 1;
}
.search__container .submit button {
  width: 100%;
}
}

@media screen and (max-width: 767px) {
.search__container {
  max-width: 100%;
  flex-wrap: wrap;
}
.tax {
  flex-basis: 100%;
  flex-grow: 1;
}
.zip {
  flex-basis: 100%;
  flex-grow: 1;
}
.cta {
  flex-basis: 100%;
  flex-grow: 1;
}
.search__container .error_msg {
  position: relative;
}
.search__container .warn_msg {
  position: relative;
}
.search__container .submit button {
  margin-top: 1.4rem;
}
}

@media screen and (max-width: 600px) {
  .tooltip .tooltiptext {
  min-width: 18rem;
  max-width: 18rem;
  left: calc(-16rem / 2);
  top: 100%;
  margin-top: .5rem;
}
}
</style>
